import type { Content } from 'pdfmake/interfaces';
import type { ViewBlock } from '@/data/schemas';
import { cm, pdfColors } from '../../theme.pdf';

type GridBlock = Extract<ViewBlock, { type: 'grid' }>;

type BlockRenderer = (block: ViewBlock) => Content;

export function renderGridBlockWithDivider(block: GridBlock, renderBlock: BlockRenderer): Content {
  const hasDivider = block.columns.length > 1;

  return {
    table: {
      widths: block.columns.map((col) => col.width ?? '*'),
      body: [
        block.columns.map((col) => ({
          stack: col.blocks.map((child) => renderBlock(child)),
          margin: [0, 0, 0, 0],
        })),
      ],
    },
    layout: {
      hLineWidth: () => 0,
      vLineWidth: (i: number) => (hasDivider && i === 1 ? 0.5 : 0),
      vLineColor: () => pdfColors.borderGray,
      paddingLeft: () => cm(0.05),
      paddingRight: () => cm(0.05),
      paddingTop: () => cm(0.05),
      paddingBottom: () => cm(0.05),
    },
    margin: [0, 0, 0, 0],
  };
}
